import { render } from "./CustomDropdown.vue?vue&type=template&id=5f2da4bd"
import script from "./CustomDropdown.ts?vue&type=script&lang=js"
export * from "./CustomDropdown.ts?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__